<template>
  <a-modal v-model:visible="visible" title="温馨提示" width="450px" :maskClosable="false" :closable="false">
    <div class="box">
      <div class="tip">
        <img src="~@/assets/tongzhi.jpg" alt="" style="width: 400px; height: 500px" />
      </div>
      <!-- <div class="kefuImg" style="text-align: center">
        <img src="https://static.zzbtool.com/static/dyorder/1688_duan/zfb.jpg" width="260" height="260" />
      </div> -->
    </div>
    <template #footer>
      <a-button type="primary" danger @click="reload">关闭窗口</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: false,

      // courseUrl: 'https://www.yuque.com/qiangzi-0veiu/ge9g4z/dfpcbn2irt604115?singleDoc#'
      courseUrl: "https://www.yuque.com/qiangzi-0veiu/ge9g4z/cu1bt6etzw37apmz?singleDoc",
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    reload() {
      this.visible = false;
    },
    openPage() {
      window.open(this.courseUrl);
    },
  },
};
</script>
<style scoped lang="less">
.box {
  .tip {
    font-size: 18px;
    margin-bottom: 1em;
  }
}
</style>
